// Verify Button
// --------------
// Opens the VerifyModal where the user can see instructions and trigger the check.

import { useState, useCallback } from "react";
import VerifyModal from "@/components/webApplication/VerifyModal";
import WebApplicationClass from "@/models/webApplication";

interface VerifyButtonProps {
  webappid: string;
  webapp: WebApplicationClass;
  appVerifiedSuccess: (webappid: string) => void;
}

export default function VerifyButton({ webappid, webapp, appVerifiedSuccess }: VerifyButtonProps) {
  const [showModal, setShowModal] = useState(false);

  const handleVerified = useCallback(() => {
    appVerifiedSuccess(webappid);
  }, [appVerifiedSuccess, webappid]);

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="inline-flex items-center justify-center rounded-md border border-transparent bg-amber-500 px-3 py-1 text-sm font-medium text-white transition-colors hover:bg-amber-600 cursor-pointer"
      >
        Verify
      </button>
      <VerifyModal
        webapp={webapp}
        show={showModal}
        close={() => setShowModal(false)}
        onVerified={handleVerified}
      />
    </>
  );
}
